<template>
  <b-card title="Müşteri Bilgileri">
    <b-list-group>
      <list-item
        title="Müşteri Tipi"
        :value="dataItem.customer_type"
      />
      <list-item
        title="Firma Adı"
        :value="dataItem.company"
      />
      <list-item
        title="İlgili Kişi"
        :value="dataItem.name"
      />
      <list-item
        title="Telefon"
        :value="dataItem.phone"
      />
      <list-item
        title="Telefon 2"
        :value="dataItem.phone2"
      />
      <list-item
        title="Fax"
        :value="dataItem.fax"
      />
      <list-item
        title="E-Posta"
        :value="dataItem.email"
      />
      <list-item
        title="Sektör"
        :value="dataItem.sector"
      />
      <list-item
        title="İlk Temas"
        :value="dataItem.meet"
      />
      <list-item
        title="Notlar"
        :value="dataItem.notes"
      />
    </b-list-group>
  </b-card>
</template>

<script>
import { BCard, BListGroup } from 'bootstrap-vue'
import ListItem from '@/views/Customers/View/ListItem.vue'

export default {
  name: 'Customer',
  components: {
    BCard,
    BListGroup,
    ListItem,
  },
  computed: {
    dataItem() {
      return this.$store.getters['customers/dataItem']
    },
  },
}
</script>

<style scoped>

</style>
